<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="isVisibleTextParserInboxes ? 'd-none' : ''"
  [config]="pageConfig"
  (onAdd)="onCreate('', false)"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
        [ngClass]="currentDateTime > item.endDateTime ? 'tr-expired' : ''"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- title -->
        <td>
          <td-value copyToClipboard [value]="item?.title"></td-value>
        </td>

        <!-- isActive -->
        <td>
          <td-value type="boolean" [value]="item?.isActive"></td-value>
        </td>

        <!-- isChildrenChange -->
        <td>
          <td-value type="boolean" [value]="item?.isChildrenChange"></td-value>
        </td>

        <!-- startDateTime -->
        <td>
          <td-value type="dateTime" [value]="item?.startDateTime"></td-value>
        </td>

        <!-- endDateTime -->
        <td>
          <td-value type="dateTime" [value]="item?.endDateTime"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->
        <td class="sticky-td">
          <!-- <app-table-operations [model]="item" (onDelete)="onDelete($event.id,$event.title)"
            (onUpdate)="onUpdate(item.id)">
          </app-table-operations> -->

          <div app-menu-btn [matMenuTriggerFor]="menu" [isShowDotsMenu]="true"></div>

          <mat-menu #menu="matMenu" xPosition="before">
            <!-- text parser inboxes button -->
            <div app-menu-btn icon="mdi mdi-account-multiple mdi-20px" color="indigo" [title]="'common.pollParserInboxes' | translate"
              (click)="getPollParserFormula(item.id)"></div>

            <!-- edit button -->
            <div app-menu-btn icon="edit" color="navyBlue" (click)="onUpdate(item.id)"></div>


            <!-- delete button -->
            <div app-menu-btn icon="delete" color="red" (click)="onDelete(item.id, item.title)"></div>

          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-text-parser-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-text-parser-form>
</ng-container>

<!--------------------------------------------------------------- Audit ---------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>

<!--text parser inboxes-->
<ng-container *ngIf="isVisibleTextParserInboxes">
  <app-text-parser-inboxes
    [textParserId]="textParserId"
    [targetFormulaId]="targetFormulaId"
    (closeTextParserInboxesPage)="isVisibleTextParserInboxes = false"
  ></app-text-parser-inboxes>
</ng-container>
